export interface UserRolesCloner {
    fromUserId: number;
    toUserId: number;
    copyStaffConfig: boolean;
    copyUserSections: boolean;
    copyReceiveOrder: boolean;
    copyNurseSections: boolean;
}